module.exports = "img/member_chevron.4163a20.png";